console.log("v1");

class BackendAPI {
  constructor() {
    this.accessToken = window.customer?.accessToken || "";
    this.apiUrl = window.BACKEND_BASE_URL;
    this.apiNodeUrl = window.BACKEND_NODE_BASE_URL;

    this.headers = {
      Authorization: `Bearer ${this.accessToken}`,
      Accept: "application/json",
    };
  }

  async getAssociate(distributorId) {
    const url = `${this.apiUrl}/partner/associates/${distributorId}`;
    return await fetch(url, {
      method: "GET",
      headers: this.headers,
    }).then(async (res) => {
      if (!res.ok)
        return res.text().then((text) => {
          throw new Error(text);
        });
      return res.json();
    });
  }

  // Minimum of regular products that conditioned products require. It comes from the backend,
  // which reads the shop metafield custom.conditioned_amount (the one the checkout Function reads).
  async getConditionedAmount() {
    const url = `${this.apiUrl}/orders/conditioned-amount`;
    return await fetch(url, {
      method: "GET",
      headers: this.headers,
    }).then(async (res) => {
      if (!res.ok)
        return res.text().then((text) => {
          throw new Error(text);
        });
      return res.json();
    });
  }

  async createAssociateOrder(distributorId, data) {
    const url = `${this.apiUrl}/partner/associates/${distributorId}/orders`;
    return await fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
      headers: this.headers,
    }).then(async (res) => {
      if (!res.ok)
        return res.text().then((text) => {
          throw new Error(text);
        });
      return res.json();
    });
  }

  async createEnrollmentCustomer(data) {
    const url = `${this.apiUrl}/enrollment/prospect`;
    return await fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
            headers: {
        ...this.headers,
        "Content-Type": "application/json",
      },
    }).then(async (res) => {
      if (!res.ok)
        return res.text().then((text) => {
          throw new Error(text);
        });
      return res.json();
    });
  }
}

// Initialize the backend API and make it available globally
window.backend = new BackendAPI();
